<div class="contract-parties" (click)="showDetailedParties=!showDetailedParties">
  <div class="contract-parties-title" > {{'CONTRACTS.CARD.PARTIES'|translate}} 
      <mat-icon  class="black-icon" style="width: 18px;" [svgIcon]="showDetailedParties?  'arrow-up-s-line' : 'arrow-down-s-line'"></mat-icon> 
  </div>
<!--   <div class="contract-parties-more" (click)="showDetailedParties=!showDetailedParties">
    <mat-icon  
      class="accent-icon contract-parties-more-icon"
      [svgIcon]="showDetailedParties? 'arrow-up-s-line' :'arrow-down-s-line'">
    </mat-icon>
    <div  class="contract-parties-more-label" >  {{(showDetailedParties? 'CONTRACTS.CARD.LESS':'CONTRACTS.CARD.MORE')|translate}}</div>
  </div> -->
  <app-component-loading [size]="'inline'" [margin]="'20px'" *ngIf="!(contractAvatarsService.bSubAvatarsReady|async)"></app-component-loading>
  <ng-template #context_menu>
    <app-contract-context-menu 
      [inputData]="selectedGuid" 
      [targetContext]="'contractParty'"
      [contractGuid]="contractGuid"
      ></app-contract-context-menu>
  </ng-template>
  <div class="contract-parties-members" *ngIf="!showDetailedParties && (contractAvatarsService.bSubAvatarsReady|async)===true">
    <app-contract-avatar  *ngFor="let signer of allParties"  
      [cdkContextMenuTriggerFor]="context_menu" 
      (contextmenu)="onRightClick($event,signer.guid)" 
      [avatarSize]="'50px'"
      [userGuid]="signer.guid" 
      [checkedState]="signer.signed">
    </app-contract-avatar>
  </div>
  <div class="contract-parties-members-detail" *ngIf="showDetailedParties">
    <div *ngFor="let project of companies" >
      <span class="contract-parties-members-detail-title">{{ project?.project.name | titlecase}}</span>
      <div class="contract-parties-members">
        <app-contract-avatar *ngFor="let signer of project?.members?.signatories"
                             [cdkContextMenuTriggerFor]="context_menu"
                             (contextmenu)="onRightClick($event, signer.member.guid)"
          [avatarSize]="'50px'"
          [userGuid]="signer.member.guid" 
          [checkedState]="!!signer.verified_at">
        </app-contract-avatar>
      </div> 
    </div>

    <div class="" *ngIf="privates?.length">
      <span  class="contract-parties-members-detail-title">{{'CONTRACTS.CARD.PARTIES_GROUP.PERSONS'|translate}}</span>
      <div class="contract-parties-members">
        <app-contract-avatar *ngFor="let private of privates" 
          [cdkContextMenuTriggerFor]="context_menu" 
          (contextmenu)="onRightClick($event,private.member.guid)"
          [avatarSize]="'50px'"
          [userGuid]="private.member.guid" 
          [checkedState]="!!private.verified_at">
        </app-contract-avatar>
      </div> 
    </div>
    <div style="min-height: 75px;" *ngIf="observers?.length">
      <span class="contract-parties-members-detail-title">{{'CONTRACTS.CARD.PARTIES_GROUP.OBSERVERS'|translate}}</span>
      <div class="contract-parties-members"  *ngIf="hideBlockToUpdate===false">
        <app-contract-avatar *ngFor="let observer of observers" 
          [cdkContextMenuTriggerFor]="context_menu" 
          (contextmenu)="onRightClick($event,observer)" 
          [avatarSize]="'50px'"
          [userGuid]="observer" 
          [checkedState]="false">
        </app-contract-avatar>
      </div> 
  </div>
    <div style="min-height: 75px;" *ngIf="signersWithoutProject?.length">
      <span class="contract-parties-members-detail-title">{{'CONTRACTS.CARD.PARTIES_GROUP.signerWithoutProject'|translate}}</span>
      <div class="contract-parties-members" *ngIf="hideBlockToUpdate===false">
          <app-contract-avatar  *ngFor="let signerWithoutProject of signersWithoutProject; trackBy:signerWithoutProject"
          [cdkContextMenuTriggerFor]="context_menu" 
          (contextmenu)="onRightClick($event,signerWithoutProject)" 
          [avatarSize]="'50px'"
          [userGuid]="signerWithoutProject" 
          [checkedState]="false">
        </app-contract-avatar>
      </div> 
  </div>

</div>           
<button
  class="button-icon size-l outline-button" 
  [disabled]="
    !allParties||
    !isCurrentMemberInContract"
  (click)="openAddMemberForm()">
  <mat-icon svgIcon="user-add-fill" style="width: 20px;"></mat-icon>
  <span>   {{'CONTRACTS.BUTTONS.ADD'|translate}}   </span>
</button>